<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['currencies.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'CURRENCIES.CURRENCIES_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([], ['currencies.update_rates'])"
        type="button"
        class="btn btn-secondary"
        (click)="updateRates()"
      >
        {{ 'CURRENCIES.CURRENCIES_LIST.UPDATE_RATES' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([], ['currencies.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'CURRENCIES.CURRENCIES_LIST.ADD_CURRENCY' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="currenciesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Currencies', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="exchange_rate"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.EXCHANGE_RATE' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('exchange_rate')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="code"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.CODE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('code')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="symbol"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.SYMBOL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('symbol')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="order_index"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.ORDER_INDEX' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('order_index')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="updated_at"
      title="Updated at"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('updated_at')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.updated_at?.getDateTime() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'CURRENCIES.CURRENCIES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button *ngIf="accessService.hasAccess([], ['currencies.show'])" (click)="edit(dataItem)">
        </app-edit-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([], ['currencies.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
